import { t as StyledSvgIcon } from "./SvgIcon.styles-D2P4wvY9.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/feather/X octagon.svg?react
const SvgXOctagon = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React$1.createElement("path", {
	d: "M15 9L9 15M9 9L15 15M7.86 2H16.14L22 7.86V16.14L16.14 22H7.86L2 16.14V7.86L7.86 2Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));

//#endregion
//#region src/icons/XOctagonIcon.tsx
function XOctagonIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgXOctagon,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { XOctagonIcon as t };
//# sourceMappingURL=XOctagonIcon-jJLjHoOb.js.map